var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "information-list2" } }, [
    _c("div", { staticClass: "headtitle" }, [
      _vm._v(_vm._s(_vm.$t("message.userInfo"))),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.fullName")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          _c(
            "span",
            { staticClass: "ml-2 d-flex align-items-center" },
            [
              !!_vm.activeConversation.whatsappNumber
                ? _c(
                    "a-avatar",
                    {
                      key: _vm.activeConversation._id,
                      staticClass: "mr-2",
                      staticStyle: {
                        "background-color": "#3899ff",
                        "border-radius": "7px !important",
                      },
                      attrs: {
                        size: 30,
                        src: _vm.getVisitorAvatarSrc(),
                        username: _vm.activeConversation.fullname || "-",
                        shape: "square",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            (_vm.activeConversation.fullname || "")
                              .substr(0, 1)
                              .toLocaleUpperCase()
                          ) +
                          "\n                    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "visitorNameInput",
                  staticClass:
                    "visitorName disableShortcut darkSpan ml-1 ellipsis",
                  class: {
                    active: _vm.visitorNameInputActive,
                  },
                  attrs: { contentEditable: "true" },
                  on: {
                    blur: function ($event) {
                      return _vm.setVisitorNameInputActive(false)
                    },
                    focus: function ($event) {
                      return _vm.setVisitorNameInputActive(true)
                    },
                    focusUserInput: function ($event) {
                      return _vm.focusVisitorNameInput()
                    },
                    keydown: _vm.handleVisitorNameInputKeyDown,
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.activeConversation.fullname) +
                      "\n                        "
                  ),
                  _c("ActionEdit", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                      },
                    ],
                    staticStyle: { "font-size": "10px !important" },
                    attrs: {
                      content: _vm.$t("message.clickToEdit"),
                      height: "11",
                      width: "11",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(_vm._s(_vm.$t("message.email"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          _c(
            "span",
            {
              staticClass: "ml-2 d-flex align-items-center",
              staticStyle: { color: "#3899ff" },
            },
            [
              _c("a-icon", { staticClass: "mr-2", attrs: { type: "mail" } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "visitorEmailInput",
                  staticClass: "visitorEmail disableShortcut",
                  class: {
                    active: _vm.visitorEmailInputActive,
                    "text-primary": _vm.activeConversation.email === "",
                  },
                  attrs: { contentEditable: "true" },
                  on: {
                    blur: function ($event) {
                      return _vm.setVisitorEmailInputActive(false)
                    },
                    focus: function ($event) {
                      return _vm.setVisitorEmailInputActive(true)
                    },
                    focusUserInput: function ($event) {
                      return _vm.focusVisitorEmailInput()
                    },
                    keydown: _vm.handleVisitorEmailInputKeyDown,
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.activeConversation.email === ""
                          ? _vm.$t("message.addEmail")
                          : _vm.activeConversation.email
                      ) +
                      "\n                        "
                  ),
                  _c("ActionEdit", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("message.clickToEdit"),
                      height: "11",
                      width: "11",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      Array.isArray(_vm.activeConversation.customLoginInfos) &&
      _vm.activeConversation.customLoginInfos.length
        ? _c(
            "div",
            _vm._l(_vm.getCustomLoginInfos(), function (inputValue, index) {
              return _c("div", { key: index, staticClass: "userInfo" }, [
                _c("div", { staticClass: "userInfo first" }, [
                  _vm._v(_vm._s(inputValue.name)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo sec" }, [
                  _vm._v(_vm._s(inputValue.value)),
                ]),
              ])
            }),
            0
          )
        : _c("div", [
            _vm.getSubjectName(_vm.activeConversation.subject)
              ? _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.department")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userInfo sec" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.getSubjectName(_vm.activeConversation.subject)
                        ) +
                        "\n                "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.representative")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.getAgentNames(_vm.activeConversation).length > 15
                  ? _vm.getAgentNames(_vm.activeConversation).slice(0, 15) +
                      "..."
                  : _vm.getAgentNames(_vm.activeConversation)
              ) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "userInfo" }, [
          _c("div", { staticClass: "userInfo first" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t("message.country")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _vm.getCountryCode(
            _vm.$_.get(_vm.activeConversation, "geoLocation.country") ||
              _vm.activeConversation.languageCode
          )
            ? _c(
                "div",
                {
                  staticClass: "userInfo sec",
                  staticStyle: { "padding-top": "2px" },
                },
                [
                  _c("country-flag", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                      },
                    ],
                    attrs: {
                      content: _vm.getCountryName(
                        _vm.$_.get(
                          _vm.activeConversation,
                          "geoLocation.country"
                        ) || _vm.activeConversation.languageCode
                      ),
                      country: _vm.getCountryCode(
                        _vm.$_.get(
                          _vm.activeConversation,
                          "geoLocation.country"
                        ) || _vm.activeConversation.languageCode
                      ),
                      size: "normal",
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                        theme: _vm.isDarkMode ? "light-border" : "google",
                      },
                      expression:
                        "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                    },
                  ],
                  staticClass: "userInfo sec",
                  attrs: {
                    content: _vm.getCountryName(
                      _vm.$_.get(
                        _vm.activeConversation,
                        "geoLocation.country"
                      ) || _vm.activeConversation.languageCode
                    ),
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.activeConversation.geoLocation
                          ? _vm.activeConversation.geoLocation.country
                          : "N/A"
                      ) +
                      "\n                "
                  ),
                ]
              ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo pl-3" }, [
          _c("div", { staticClass: "userInfo first" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t("message.language")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "userInfo sec",
              staticStyle: { "padding-top": "10px" },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.activeConversation.languageCode) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.chatLanguage")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "userInfo sec",
            staticStyle: { "padding-top": "10px" },
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.activeConversation.visitor.preferredLang,
                    expression: "activeConversation.visitor.preferredLang",
                  },
                ],
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.activeConversation.visitor,
                        "preferredLang",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.updateVisitorLang,
                  ],
                },
              },
              _vm._l(_vm.languages, function (lang) {
                return _c("option", { domProps: { value: lang.code } }, [
                  _vm._v(_vm._s(lang.originalName)),
                ])
              }),
              0
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.visitingPage")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "userInfo sec",
            staticStyle: {
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
            },
          },
          [
            _vm.activeConversation.visitingPage
              ? _c(
                  "a",
                  {
                    staticClass: "info-label",
                    attrs: {
                      href: _vm.activeConversation.visitingPage
                        ? _vm.activeConversation.visitingPage
                        : "#",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.activeConversation.visitingPage))]
                )
              : _c("span", [_vm._v("N/A")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.osAndBrowser")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          !_vm.activeConversation.whatsappNumber
            ? _c("div", { staticClass: "userInfo sec" }, [
                _vm.activeConversation.visitor.os &&
                _vm.activeConversation.visitor.browser
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.activeConversation.visitor.os) +
                          " / " +
                          _vm._s(_vm.activeConversation.visitor.browser)
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getUserDetailedLoginInfo(
                              _vm.activeConversation.userAgent
                            )
                          )
                      ),
                    ]),
              ])
            : _c("div", { staticClass: "userInfo sec" }, [_vm._v("whatsapp")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [_vm._v("IP")]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.activeConversation.ipAddress) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(_vm._s(_vm.$t("message.chatId"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          _vm._v(_vm._s(_vm.activeConversation._id)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.customerClientVersion")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                (
                  this.activeConversation.visitor.version || {
                    version: -1,
                    versionStr: "N/A",
                    buildNumber: -1,
                    commitHash: "",
                  }
                ).versionStr
              ) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userInfo" }, [
        _c("div", { staticClass: "userInfo first" }, [_vm._v("Note")]),
        _vm._v(" "),
        _c("div", { staticClass: "userInfo sec" }, [
          _c(
            "div",
            { staticClass: "rep-note-element" },
            [
              _c("div", { staticClass: "rep-note-name" }, [
                _vm._v(_vm._s(_vm.noteSender)),
              ]),
              _vm._v(" "),
              _c("a-textarea", {
                staticClass: "disableShortcut",
                on: {
                  focus: function ($event) {
                    _vm.isEditingOpen = true
                  },
                },
                model: {
                  value: _vm.info,
                  callback: function ($$v) {
                    _vm.info = $$v
                  },
                  expression: "info",
                },
              }),
              _vm._v(" "),
              _vm.isEditingOpen
                ? _c(
                    "div",
                    { staticClass: "rep-note-actions" },
                    [
                      _c(
                        "a-button-group",
                        { attrs: { size: "small" } },
                        [
                          _c("a-button", {
                            attrs: { icon: "close", type: "danger" },
                            on: { click: _vm.notSaveInfo },
                          }),
                          _vm._v(" "),
                          _c("a-button", {
                            attrs: { icon: "check", type: "primary" },
                            on: { click: _vm.saveInfo },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }